// @flow
import React, { Component } from 'react';
import { Text, asField } from 'informed';
import ReactTooltip from 'react-tooltip';

/*
  Text that validates input parameter regex, used for misc cases
  Takes in field, initialValue, regex, and errorText, and any other 'informed' input props as props
*/

type Props = {
  field: string,
  fieldState: Object,
  fieldApi: Object,
  initialValue?: ?string,
  errorText: string,
}

class ValidateText extends Component<Props> {
  render() {
    const {
      field, fieldState, initialValue, errorText, ...props
    } = this.props;

    return (
      <span>
        <Text
          field={field}
          initialValue={initialValue}
          style={fieldState.error && { border: '2px solid #FF6363', outline: '0px' }}
          data-tip
          data-for={field}
          {...props}
        />
        {fieldState.error
          && <ReactTooltip id={field} type='error' effect='solid'>
            <span>{errorText}</span>
          </ReactTooltip>
        }
      </span>
    );
  }
}

const ValidateTextComponent = asField(ValidateText);

type WrapperProps = {
  field: string,
  initialValue?: ?string,
  regex: Object,
  errorText: string,
}

class ValidateTextWrapper extends Component<WrapperProps> {
  validate = (value: string) => (this.props.regex.test(value) ? null : 'Error');

  render() {
    const {
      field, initialValue, errorText, ...rest
    } = this.props;
    return <ValidateTextComponent
      validate={this.validate}
      validateOnChange
      field={field}
      initialValue={initialValue}
      errorText={errorText}
      {...rest}
    />;
  }
}

export default ValidateTextWrapper;



// WEBPACK FOOTER //
// ./client/src/components/ValidateText.jsx